
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAnalyses } from '@/hooks/useAnalyses';
import AnalysisCard from '@/components/analyses/AnalysisCard';
import ProgressCard from '@/components/analyses/ProgressCard';
import PendingCard from '@/components/analyses/PendingCard';
import EmptyState from '@/components/analyses/EmptyState';

const Analyses = () => {
  const navigate = useNavigate();
  const { 
    completedAnalyses, 
    inProgressAnalyses, 
    pendingAnalyses, 
    loading, 
    startAnalysis, 
    updateProgress 
  } = useAnalyses();

  return (
    <DashboardLayout>
      <div className="px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-darkgray">Upphandlingsanalyser</h1>
            <p className="text-gray-600 mt-1">
              Översikt över alla genomförda och pågående analyser
            </p>
          </div>
          <Button 
            onClick={() => navigate('/new-procurement')}
            className="mt-4 sm:mt-0"
          >
            Skapa ny analys
          </Button>
        </div>

        {loading ? (
          <div className="text-center py-20">
            <div className="animate-spin h-10 w-10 border-4 border-yellow-500 border-opacity-50 border-t-darkgray rounded-full mx-auto"></div>
            <p className="mt-4 text-gray-500">Laddar analyser...</p>
          </div>
        ) : (
          <Tabs defaultValue="completed" className="space-y-6">
            <TabsList>
              <TabsTrigger value="completed">Färdiga analyser ({completedAnalyses.length})</TabsTrigger>
              <TabsTrigger value="in-progress">Pågående ({inProgressAnalyses.length})</TabsTrigger>
              <TabsTrigger value="pending">Väntande ({pendingAnalyses.length})</TabsTrigger>
            </TabsList>
            
            <TabsContent value="completed" className="space-y-6">
              {completedAnalyses.length === 0 ? (
                <EmptyState type="completed" />
              ) : (
                completedAnalyses.map((analysis) => (
                  <AnalysisCard key={analysis.id} analysis={analysis} />
                ))
              )}
            </TabsContent>
            
            <TabsContent value="in-progress" className="space-y-6">
              {inProgressAnalyses.length === 0 ? (
                <EmptyState type="in-progress" />
              ) : (
                inProgressAnalyses.map((analysis) => (
                  <ProgressCard 
                    key={analysis.id} 
                    analysis={analysis} 
                    onUpdate={updateProgress}
                  />
                ))
              )}
            </TabsContent>
            
            <TabsContent value="pending" className="space-y-6">
              {pendingAnalyses.length === 0 ? (
                <EmptyState type="pending" />
              ) : (
                pendingAnalyses.map((procurement) => (
                  <PendingCard 
                    key={procurement.id} 
                    procurement={procurement} 
                    onStartAnalysis={startAnalysis}
                  />
                ))
              )}
            </TabsContent>
          </Tabs>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Analyses;
